import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from './Zccs.ducks';

import ZccAdd from './components/ZccAdd';
import ZccForm from './components/ZccForm';
import ZccListItem from './components/ZccListItem';
import Heading from 'zignal-landscape/lib/Heading';
import ConfirmationModal from 'zignal-landscape/lib/ConfirmationModal';


// Be explicit of the state, not just return everything. This allows for
// clear understanding of what is needed if mixed with other state props.
const mapStateToProps = (
  (state) => ({
    // List
    zccList: state.Zccs.zccList,
    zccById: state.Zccs.zccById,
    // CRUD
    addZcc: state.Zccs.addZcc,
    editZcc: state.Zccs.editZcc,
    deleteZcc: state.Zccs.deleteZcc,
    // Errors
    fetchZccsError: state.Zccs.fetchZccsError,
    addZccError: state.Zccs.addZccError,
    editZccError: state.Zccs.editZccError,
    deleteZccError: state.Zccs.deleteZccError,
    // Flags
    addingZcc: state.Zccs.addingZcc,
    editingZcc: state.Zccs.editingZcc,
    deletingZcc: state.Zccs.deletingZcc,
    cancelZcc: state.Zccs.cancelZcc,
    confirmDeleteZcc: state.Zccs.confirmDeleteZcc,
  })
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class Zccs extends Component {

  componentDidMount() {
    const { fetchZccs, accountId } = this.props;
    fetchZccs({accountId});
  }

  render() {
    const { accountId,
      zccList, zccById,
      addingZcc, startAddingZcc, addZccError,
      editingZcc, startEditingZcc, editZccError,
      deletingZcc, confirmDeleteZcc,
      cancelZcc, addZcc, editZcc, deleteZcc } = this.props;

    const renderAddButton = (
      editingZcc ? null : <ZccAdd onNewClick={startAddingZcc} />
    );

    const renderForm = (initialValues={}, onSubmit, errors) => {
      return (
        <ZccForm
          key={initialValues._id || 'new'}
          initialValues={initialValues}
          onSubmit={onSubmit}
          onCancel={cancelZcc}
          errors={errors}
        />
      );
    };

    const renderList = zccList.map((id) => {
      const zcc = zccById[id];
      const {_id, name} = zcc;
      return (
        (editingZcc === id) ? renderForm({_id, accountId, name}, editZcc, editZccError) : (
          <ZccListItem
            key={id}
            zcc={zcc}
            onEditClick={startEditingZcc}
            onDeleteClick={confirmDeleteZcc}
            disableMenu={!!(addingZcc || editingZcc)}
          />
        )
      );
    });

    const zccToDelete = zccById[deletingZcc] || {};
    return (
      <div>
        <Heading>Command Centers</Heading>
        {renderList}
        {addingZcc ? renderForm({accountId}, addZcc, addZccError) : renderAddButton}
        <ConfirmationModal
          title="Are you sure?"
          confirmStyle="delete"
          onConfirm={() => {deleteZcc(zccById[deletingZcc]);}}
          onCancel={cancelZcc}
          isOpen={!!(deletingZcc)}
        >
          Are you sure you want to delete <b>{zccToDelete.name}</b>?
        </ConfirmationModal>
      </div>
    );
  }
}

Zccs.propTypes = {
  accountId: PropTypes.string,
  zccList: PropTypes.array,
  zccById: PropTypes.object,
  fetchZccs: PropTypes.func,
  fetchZccsError: PropTypes.object,
  addZccError: PropTypes.object,
  editZccError: PropTypes.object,
  deleteZccError: PropTypes.object,
  addZcc: PropTypes.func,
  editZcc: PropTypes.func,
  deleteZcc: PropTypes.func,
  addingZcc: PropTypes.bool,
  confirmDeleteZcc: PropTypes.func,
  startAddingZcc: PropTypes.func,
  editingZcc: PropTypes.string,
  deletingZcc: PropTypes.string,
  startEditingZcc: PropTypes.func,
  cancelZcc: PropTypes.func
};

Zccs.defaultProps = {
  zccList: [],
  zccById: {},
  fetchZccsError: null,
  addZccError: null,
  editZccError: null,
  deleteZccError: null,
  addingZcc: false,
  editingZcc: undefined,
  deletingZcc: undefined,
  confirmDeleteZcc: false,
};

export default connect(mapStateToProps, actions, mergeProps)(Zccs);
